// @flow
import HubTrouverRugby from 'components/hubtrouverrugby/HubTrouverRugby';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/hubtrouverrugby/HubTrouverRugby';

export default connect(
  (state: StateType): StateProps => ({
    trouver_pratiques: state.settingsState.trouver_pratiques,
    userPref: state.userState.userPref
  })
)(HubTrouverRugby);
